// assets/src/js/modules/sliders.js
import Swiper from "swiper/bundle";

import "swiper/css/bundle";

export default function initSliders() {
  // Hero slider
  const cryptoCaro = new Swiper(".crypto_caro_slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".crypto-caro-next",
      prevEl: ".crypto-caro-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 3,
      },
      1400: {
        slidesPerView: 5,
      },
    },
  });

  const supportCaro = new Swiper(".support_caro_slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".support-caro-next",
      prevEl: ".support-caro-prev",
    },
  });
}
